import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common'; 
import { LogoutModalComponent } from './logoutModal.component';

@NgModule({
  declarations: [
    LogoutModalComponent
  ],
  imports: [
    CommonModule // ✅ Required
  ],
exports: [LogoutModalComponent],
 
})
export class autoLogoutModule { }
